import { render, staticRenderFns } from "./SingleGeneralDialog.vue?vue&type=template&id=0dc40005&scoped=true"
import script from "./SingleGeneralDialog.vue?vue&type=script&lang=js"
export * from "./SingleGeneralDialog.vue?vue&type=script&lang=js"
import style0 from "./SingleGeneralDialog.vue?vue&type=style&index=0&id=0dc40005&prod&lang=scss&scoped=true"
import style1 from "./SingleGeneralDialog.vue?vue&type=style&index=1&id=0dc40005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc40005",
  null
  
)

export default component.exports